"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.ICON = exports.INVALID_TAG = exports.DISABLED_TAG = exports.TAG = void 0;

var _cxs = _interopRequireDefault(require("cxs")),
    _vars = require("../../../common/styles/vars"),
    TAG = (0, _cxs["default"])({
  alignItems: "center",
  backgroundColor: _vars.COLOURS.cyan.jungleGreen.monkey,
  borderRadius: "3px",
  display: "inline-flex",
  justifyContent: "center",
  padding: "1px 8px 0 8px",
  height: "25px",
  " > p": {
    color: _vars.COLOURS.grey.athens.parthenon,
    fontWeight: _vars.FONT_WEIGHTS.medium,
    fontSize: _vars.FONT_SIZES.small,
    padding: 0,
    overflow: "hidden",
    margin: "auto",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    display: "block",
    lineHeight: "14px",
    userSelect: "none"
  }
});

exports.TAG = TAG;
var DISABLED_TAG = (0, _cxs["default"])({
  background: _vars.COLOURS.grey.mischka.michael,
  " > p": {
    color: _vars.COLOURS.grey.denim
  }
});
exports.DISABLED_TAG = DISABLED_TAG;
var INVALID_TAG = (0, _cxs["default"])({
  background: _vars.COLOURS.red.redApple
});
exports.INVALID_TAG = INVALID_TAG;
var ICON = (0, _cxs["default"])({
  marginLeft: "10px",
  outlineColor: "white !important",
  outlineWidth: "thin",
  ":focus": {
    outlineStyle: "solid"
  }
});
exports.ICON = ICON;